export enum SocialFeedType {
    ForYou = "for-you",
    Following = "following",
    Friends = "friends",
}